export default __webpack_public_path__ + "static/WeiJuinProfilePic-82a809bdbcd81d8a6c6ed0a9f65cfcef.jpg";